import React from 'react';
import { Link as PortalLink } from '@fortress-technology-solutions/fortress-component-library/Atoms_Portal';
import { Link as ReactRouterLink } from 'react-router-dom';

const Link = ({ to, ...props }) => (
  <PortalLink {...props} to={to} component={to ? ReactRouterLink : undefined} />
);

export default Link;
